export const DAY_IN_MILLISECONDS = 24 * 3600 * 1000;
export const DEFAULT_ATTRIBUTION_WINDOW = 365;

export function getExpiryTimeFromDays(
  d?: number,
  startDate: number = Date.now(),
) {
  if (!d || d <= 0) {
    // if days not set return default expiration time in 365d.
    d = DEFAULT_ATTRIBUTION_WINDOW;
  }
  return startDate + DAY_IN_MILLISECONDS * d;
}

export function isExpired(expiryTime: number): boolean {
  return Date.now() > expiryTime;
}
